import Vue from 'vue'
import dayjs from 'dayjs'
import { FormatDate } from '@/utils'

Vue.prototype.$period = (start_date, end_date) => {
  if (start_date && end_date) {
    return `${FormatDate(start_date, end_date)}`
  }
  return '-'
}

Vue.prototype.$formatDate = (date, format = 'D MMM, YYYY') => {
  let formtDate = dayjs(date)
  return formtDate.format(format)
}

Vue.prototype.$minMaxDate = (array) => {
  if (array) {
    const res = array.reduce((acc, flight) => {
      const StartDate = new Date(flight.start_date)
      const EndDate = new Date(flight.end_date)

      if (!acc.start_date || StartDate < new Date(acc.start_date)) {
        acc.start_date = flight.start_date
      }

      if (!acc.end_date || EndDate > new Date(acc.end_date)) {
        acc.end_date = flight.end_date
      }

      return acc
    }, {})

    return `${FormatDate(res.start_date, res.end_date)}`
  }
  return '-'
}

const formatNumber = (n) => {
  const num = Number(n)
  if (!isFinite(num)) return '0'
  return num.toLocaleString()
}
const formatPercent = (v) => {
  if (v == null || isNaN(v)) return '0%'
  const val = v > 1 ? v : v * 100
  const dec = val < 1 ? 2 : val < 10 ? 1 : 0
  return `${Number(val).toFixed(dec)}%`
}
const safe = (x, d = 0) => {
  const n = Number(x)
  return Number.isFinite(n) ? n : d
}

Vue.prototype.$SBCampaignStatusAccess = (statusAccess, currentStatus = 0) => {
  const status = {
    0: 'new',
    1: 'revision',
    2: 'in_review',
    3: 'approved',
    4: 'in_progress',
    5: 'ready_to_launch',
    6: 'active',
    7: 'completed',
  }

  const statusIndex = status[currentStatus]
  return statusAccess.includes(statusIndex)
}

// FILTERS
Vue.filter('formatDate', function (value) {
  if (!value) return ''
  let formtDate = dayjs(value)
  return formtDate.format('D MMM, YYYY, HH:mm')
})

Vue.prototype.$formatNumber = formatNumber
Vue.prototype.$formatPercent = formatPercent
Vue.prototype.$safe = safe
